import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getAggregations(date, options = {}) {
    const { forceReload = false } = options

    return axiosIns.get(
      '/v2/eod_closing/aggregations',
      { params: snakecaseKeys({ date, forceReload }) },
    )
  },
  enqueueAggregation(id, date, options = {}) {
    const { forceReload = false, forceRefresh = false } = options

    return axiosIns.get(
      `/v2/eod_closing/aggregations/${id}/enqueue`,
      { params: snakecaseKeys({ date, forceReload, forceRefresh }) },
    )
  },
  getAggregationJobStatus(id, date) {
    return axiosIns.get(
      `/v2/eod_closing/aggregations/${id}/status`,
      { params: { date } },
    )
  },
  // 日報β XLSX ダウンロード専用。status と同形状だが、評価日でない日でも
  // 集計表に紐づく全 BR を列として返す（欠けている列は空値）。
  getAggregationDownloadResult(id, date) {
    return axiosIns.get(
      `/v2/eod_closing/aggregations/${id}/download_result`,
      { params: { date } },
    )
  },
  getAvailableUsers(id) {
    return axiosIns.get(`/v2/eod_closing/aggregations/${id}/available_users`)
  },
}
